module.exports = __webpack_public_path__ + "img/2-1.8782d274.jpg";